"use strict";

module.exports = function () {
	var assign = Object.assign, obj;
	if (typeof assign !== "function") return false;
	obj = { foo: "raz" };
	assign(obj, { bar: "dwa" }, { trzy: "trzy" });
	return (obj.foo + obj.bar + obj.trzy) === "razdwatrzy";
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es5-ext/object/assign/is-implemented.js
 ** module id = 725
 ** module chunks = 0
 **/